module.exports = __webpack_public_path__ + "img/commodity.1aac1629.png";